import { createStubResult } from './builders';
import { paleDiagnosisResult } from './pale';
import { palzDiagnosisResult } from './palz';
import { paceDiagnosisResult } from './pace';
import { paczDiagnosisResult } from './pacz';
import { prleDiagnosisResult } from './prle';
import { prlzDiagnosisResult } from './prlz';
import { prceDiagnosisResult } from './prce';
import { prczDiagnosisResult } from './prcz';
import { saleDiagnosisResult } from './sale';
import { salzDiagnosisResult } from './salz';
import { saceDiagnosisResult } from './sace';
import { saczDiagnosisResult } from './sacz';
import { srleDiagnosisResult } from './srle';
import { srlzDiagnosisResult } from './srlz';
import { srceDiagnosisResult } from './srce';
import { srczDiagnosisResult } from './srcz';
import { CODE_TO_META, CODE_TO_PAGE_PATH, MBTI_CODES, MBTI_TYPE_REGISTRY, PAGE_NUMBER_TO_CODE } from './registry';
import type { DiagnosisResultData, MbtiCode } from './types';

export type { DiagnosisResultData, DiagnosisResultContent, MbtiCode, AaruIconKey } from './types';
export { MBTI_CODES, MBTI_TYPE_REGISTRY, CODE_TO_PAGE_PATH, PAGE_NUMBER_TO_CODE, CODE_TO_META };
export { buildDiagnosisResult, axesFromCode, codeToNo, createStubResult } from './builders';
export { DIAGNOSIS_RESULT_CTA, getDiagnosisResultCta } from './ctaTexts';
export { SITE_DRIVE_IMAGE_MAP, DRIVE_IMAGE_COUNT } from './driveImageMap';

/** 本文が確定済みのタイプ（未登録はスタブ表示） */
const COMPLETE_RESULTS: Partial<Record<MbtiCode, DiagnosisResultData>> = {
  PALE: paleDiagnosisResult,
  PALZ: palzDiagnosisResult,
  PACE: paceDiagnosisResult,
  PACZ: paczDiagnosisResult,
  PRLE: prleDiagnosisResult,
  PRLZ: prlzDiagnosisResult,
  PRCE: prceDiagnosisResult,
  PRCZ: prczDiagnosisResult,
  SALE: saleDiagnosisResult,
  SALZ: salzDiagnosisResult,
  SACE: saceDiagnosisResult,
  SACZ: saczDiagnosisResult,
  SRLE: srleDiagnosisResult,
  SRLZ: srlzDiagnosisResult,
  SRCE: srceDiagnosisResult,
  SRCZ: srczDiagnosisResult,
};

export function isDiagnosisResultComplete(code: MbtiCode): boolean {
  return code in COMPLETE_RESULTS;
}

export function getDiagnosisResultByCode(code: MbtiCode): DiagnosisResultData {
  return COMPLETE_RESULTS[code] ?? createStubResult(code);
}

export function getDiagnosisResultByPageNumber(pageNumber: number): DiagnosisResultData | undefined {
  const code = PAGE_NUMBER_TO_CODE[pageNumber];
  return code ? getDiagnosisResultByCode(code) : undefined;
}

export function getPagePathByCode(code: MbtiCode): string {
  return CODE_TO_PAGE_PATH[code];
}
